import { useHistoryInternal } from 'hooks/useHistoryInternal'
import { RowBetween, RowMiddle } from 'layout/Components/Row'
import React from 'react'
import styled from 'styled-components'
import { FlexProps } from 'UIKit/Box/types'
import BackButton from 'UIKit/Button/BackButton'
import TransText from 'UIKit/Text/TransText'

export type MobileHeaderProps = {
  title: string
  backAction?: () => void
  children?: React.ReactNode
  isBack?: boolean
  displayBorder?: boolean
} & FlexProps

const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  backAction,
  children,
  isBack,
  displayBorder,
  ...props
}) => {
  const { goBack } = useHistoryInternal()

  return (
    <Container displayBorder={displayBorder} {...props}>
      <RowMiddle height="100%" position="relative" width="100%">
        <StyledHeaderTitle>{title}</StyledHeaderTitle>
        <RowMiddle
          height="100%"
          position="absolute"
          left="0"
          right="0"
          top="0"
          justifyContent={isBack ? 'space-between' : 'flex-end'}
        >
          {isBack && <BackButton onClick={backAction || goBack} />}
          {children}
        </RowMiddle>
      </RowMiddle>
    </Container>
  )
}

const Container = styled(RowBetween)<{ displayBorder: boolean }>`
  height: ${({ theme }) => theme.mobileTopbarHeight};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  padding: 0px 12px;
  background: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ displayBorder, theme }) => (displayBorder ? theme.colors.stroke : 'transparent')};
  transition: border-color 0.2s;

  svg {
    height: 20px;
    width: 20px;
  }
`

export const StyledHeaderTitle = styled(TransText)`
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  width: 100%;
  padding: 0px 32px;
`

export default MobileHeader
